<template>
  <vs-wrapper v-if="canShowJobs">
    <div v-if="noJobs" class="no-jobs">
      No jobs assigned to this resource.<br />Try expanding your filters.
    </div>
    <field-view-job-card
      v-for="job in jobs"
      :key="job.id"
      :job="job"
      :link-to="{
        name: 'fvnext-ticket-info-panel-direct',
        params: {
          id: `${job.number}`,
        },
      }"
    />
    <div class="mt-2">
      <job-search-pagination
        v-if="hasNextPage || getCurrentPage > 1"
        :query="jobsQuery"
        :current-page="getCurrentPage"
        :update-page="updatePage"
      />
    </div>
  </vs-wrapper>
</template>

<script setup lang="ts">
import { computed, reactive, ref, toRef } from 'vue'
import { usePagination } from '@/components/jobs/pagination'
import { useJobsQuery } from '@/components/jobs/query'
import { useJobsSearch } from '@/components/jobs/search'
import { useMapFilters } from '@/components/jobs/filters'
import FieldViewJobCard from './FieldViewJobCard.vue'
import VsWrapper from '@/components/vision/VsWrapper.vue'
import JobSearchPagination from '@/components/jobs/job-search-page/JobSearchPagination.vue'

const props = defineProps<{
  resourceId: number | null
}>()

const resourceIdRef = toRef(props, 'resourceId')

const filters = useMapFilters()

const { getCurrentPage, updatePage } = usePagination()
const jobsQuery = reactive(
  useJobsQuery(
    { ...filters, resourceId: resourceIdRef },
    getCurrentPage,
    20,
    ref(['requested_start', 'number']), // sortBy
    ref([true, true]), // sortDesc
  ),
)

const {
  jobs,
  hasNextPage,
  isFetching: isFetchingJobs,
  isFetched: isFetchedJobs,
  isRefetching: isRefetchingJobs,
} = useJobsSearch(jobsQuery)

const canShowJobs = computed(() => {
  if (isFetchingJobs.value && !isRefetchingJobs.value) {
    return false
  }
  return true
})

const noJobs = computed(() => {
  return isFetchedJobs.value && jobs.value.length === 0
})
</script>

<style scoped>
.no-jobs {
  color: var(--color-grey);
  text-align: center;
  padding: var(--space-large) 0px;
}
</style>
